export class customEventsNames{
    constructor() {
        this.expandedCollapsedText = 'expandedCollapsedText';
        this.collapsedCollapsedText = 'collapsedCollapsedText'; 
    }
};
export default new customEventsNames();